import { getFormattedDateTime, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { setFocusOnField } from '@/core/core_components/form/form'
import { bindResetButtonModal } from '@/core/input_controls/button/button'

export function NotificationsManager (companyId) {
	'use strict'

	this.companyId = companyId
	this.eventTypeNames = {
		'NONE': getLocalizedMessage('event.none'),
		'ITEMS_CREATED': getLocalizedMessage('event.created.new.items'),
		'ITEMS_HAVE_CHANGED_STATUS_DURING_THE_PERIOD': getLocalizedMessage('event.items.have.changed.status.during.the.period'),
		'ITEMS_WITH_STATUS': getLocalizedMessage('event.items.with.status')
	}
	this.exportConfigs = undefined

	this.notification = {}
	this.fields = undefined
	this.statusElements = undefined

	this.action = undefined
	this.activeAttribute = undefined
	this.postSaveAction = undefined
	this.prefix = undefined

	var additionalsForTypes = {
		'ITEMS_HAVE_CHANGED_STATUS_DURING_THE_PERIOD': changedStatusDuringThePeriodSupport,
		'ITEMS_WITH_STATUS': changedStatusSupport
	}

	function changedStatusDuringThePeriodSupport (prefix, show) {
		cronExpressionToggle(prefix, show)
	}

	function changedStatusSupport (prefix, show) {
		cronExpressionToggle(prefix, show)
		var $status = $('#' + prefix + 'status')
		if (!show) {
			$status.find('button').removeClass('selected')
			$status.closest('.modal_item').hide()
		} else {
			$status.closest('.modal_item').show()
		}
	}

	function cronExpressionToggle (prefix, show) {
		if (!show) {
			$('#' + prefix + 'cronExpression').val('').closest('.modal_item').hide()
			$('#schedulerTab').hide()
		} else {
			$('#cron_description').hide()
			$('#schedulerTab').show()
			$('#' + prefix + 'cronExpression').closest('.modal_item').show()
		}
	}

	function attachEvents (manager) {
		$('#' + manager.prefix + 'event').unbind('change')
		$('#' + manager.prefix + 'event').bind('change', function () {
			changedStatusDuringThePeriodSupport(manager.prefix, false)
			changedStatusSupport(manager.prefix, false)
			var value = $('#' + manager.prefix + 'event').val()
			if (!_.isUndefined(additionalsForTypes[value])) {
				additionalsForTypes[value](manager.prefix, true)
			}
		})
	}

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.notification = properties.notification || undefined
		this.activeAttribute = properties.activeAttribute || undefined
		this.prefix = properties.prefix || 'notification_'
		this.postSaveAction = properties.postSaveAction
		this.companyId = properties.companyId
		this.fields = properties.fields || ['name', 'subject', 'event', 'cronExpression', 'exportConfigId', 'templateId']
	}

	this.init = function (table) {
		var manager = this
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'export-config/' + manager.companyId,
			async: false,

			success: function (data) {
				manager.exportConfigs = data
				manager.initTable(table)
			}
		})
	}

	this.initTable = function (table) {
		var manager = this
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'notification/' + manager.companyId + '/list',
			async: false,

			success: function (data) {
				table.setData(data)
				table.initTable()
			},
			error: function () {
				table.setData([])
				table.initTable()
			}
		})
	}

	this.initPage = function () {
		this.resetFields()
		this.loadExportConfigs()
		this.loadEventTypes()
		this.loadStatusElements()
		if (this.action == 'edit') {
			this.setNotificationInformation()
			setFocusOnField(this.activeAttribute)
		}
		this.bindNotificationStatus()
		attachEvents(this)
		bindResetButtonModal()
	}

	this.bindNotificationStatus = function () {
		$('#notification_status').on('click', '.status-element button', function () {
			if (!$(this).hasClass('selected')) {
				var $selected = $(this).closest('.status-element').find('button.selected').first()
				if ($selected[0]) $selected.toggleClass('selected')
			}
			$(this).toggleClass('selected')
		})
	}

	this.setListData = function (data, field) {
		var list = '<option value=""></option>'
		$('#' + this.prefix + field).empty()
		_.each(data, function (value) {
			list += '<option value=\'' + value['id'] + '\'>' + value['name'] + '</option>'
		})
		$('#' + this.prefix + field).html(list)
	}

	this.initEventTypes = function (data, field) {
		var manager = this
		_.each(additionalsForTypes, function (value) {
			value(manager.prefix, false)
		})
		var listContent = ''
		var $list = $('#' + this.prefix + field)
		$list.empty()
		_.each(data, function (value) {
			listContent += '<option value=\'' + value + '\'>' + manager.eventTypeNames[value] + '</option>'
		})
		$list.html(listContent)
		if (!_.isUndefined(additionalsForTypes[$list.val()])) {
			additionalsForTypes[$list.val()](this.prefix, true)
		}
	}

	this.resetFields = function () {
		var manager = this
		_.each(this.fields, function (field) {
			$('#' + manager.prefix + field).val('')
		})
		$('#' + manager.prefix + 'status').find('button').removeClass('selected')
	}

	this.prepareData = function (data) {
		var manager = this
		_.each(data, function (value) {
			value['event'] = manager.eventTypeNames[value['event']]
			if (value['exportConfigId']) {
				value['exportConfigId'] = _.find(manager.exportConfigs, function (config) {
					return value['exportConfigId'] === config['id']
				})['name']
			}
		})
	}

	this.setNotificationInformation = function () {
		var manager = this
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'notification/get',
			data: { id: manager.notification.id },
			async: false,

			success: function (data) {
				_.each(data, function (value, key) {
					var $field = $('#' + manager.prefix + key)
					$field.val(value)
					if ($field.is('select')) {
						if (!_.isUndefined(additionalsForTypes[$field.val()])) additionalsForTypes[$field.val()](manager.prefix, true)
					}
				})
				if (!_.isUndefined(data.params)) {
					if (data['event'] == 'ITEMS_WITH_STATUS') setStatusInformation(manager, data.params.status)
				}
			}
		})
	}

	function setStatusInformation (manager, data) {
		var $status = $('#' + manager.prefix + 'status')
		_.each(data, function (value, key) {
			var $element = $status.find('.status-element[data-name=' + key + ']')
			var statusSelector = value ? '.complete-status' : '.draft-status'
			$element.find(statusSelector).first().addClass('selected')
		})
	}

	this.loadExportConfigs = function () {
		var manager = this
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'export-config/' + manager.companyId,
			async: false,

			success: function (data) {
				manager.exportConfigs = data
				manager.setListData(data, 'exportConfigId')
			}
		})
	}

	this.loadEventTypes = function () {
		var manager = this
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'notification/event-types',
			async: false,

			success: function (data) {
				manager.eventTypes = data
				manager.initEventTypes(data, 'event')
			}
		})
	}

	this.loadStatusElements = function () {
		var manager = this
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'items/status-elements',
			async: false,

			success: function (data) {
				manager.statusElements = data
				initStatus(manager)
			}
		})
	}

	function initStatus (manager) {
		var $status = $('#' + manager.prefix + 'status')
		$status.html('')
		var statusContent = '<table border=\'0\' cellspacing=\'1\'>'
		_.each(manager.statusElements, function (value) {
			statusContent += '<tr class="status-element" data-name="' + value + '">'
				+ '<td>' + value + '</td>'
				+ '<td><button class="complete-status"></button><button class="draft-status"></button></td></tr>'
		})
		statusContent += '</table>'
		$status.append(statusContent)
	}

	this.updateNotificationsTable = function (table) {
		var manager = this
		$.ajax({
			type: 'POST',
			url: window.urlContext + 'notification/' + manager.companyId + '/list',
			success: function (data) {
				table.updateData(data)
			}
		})
	}

	this.deleteNotification = function (notification, table) {
		Swal.fire({
			title: getLocalizedMessage('delete') + ' ' + notification['name'] + '?',
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					type: 'POST',
					url: window.urlContext + 'notification/delete',
					data: { id: notification['id'] },
					async: false,

					success: function () {
						table.initTable()
						table.selectedItemsManager.deleteRowMarkById(notification['id'])
						showMessageAlert(getLocalizedMessage('remove.notifications.message'), 'success')
					},
					error: function () {
						showMessageAlert(getLocalizedMessage('error'), 'danger')
					}
				})
			}
		})
	}

	this.deleteNotifications = function (ids, table) {
		Swal.fire({
			title: getLocalizedMessage('notifications.remove.confirmation'),
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					type: 'POST',
					url: window.urlContext + 'notifications/delete',
					data: { ids: JSON.stringify(ids) },
					async: false,

					success: function () {
						table.initTable()
						table.selectedItemsManager.clearSelections(table)
						showMessageAlert(getLocalizedMessage('remove.notifications.message'), 'success')
					},
					error: function () {
						showMessageAlert(getLocalizedMessage('error'), 'danger')
					}
				})
			}
		})
	}

	this.saveNotification = function (notificationInformationData) {
		var manager = this
		var url = (this.action === 'edit') ? 'notification/update' : 'notification/create'
		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(notificationInformationData),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (manager.postSaveAction) {
					manager.postSaveAction()
				}
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.getNotificationInformation = function () {
		window.UIkit.tab('#notificationTab').show(0);

		var manager = this
		var notificationInformation = {}
		if (this.action == 'edit') {
			notificationInformation['id'] = this.notification.id
		}
		notificationInformation['companyId'] = this.companyId

		_.each(this.fields, function (field) {
			var $field = $('#' + manager.prefix + field)
			if ($field.is(':visible')) notificationInformation[field] = $field.val()
		})

		var params = {}

		if (notificationInformation.event == 'ITEMS_WITH_STATUS') {
			var status = {}
			_.each($('#' + manager.prefix + 'status').find('.status-element'), function (statusElement) {
				var selectedStatus = $(statusElement).find('button.selected').first()[0]
				if (selectedStatus) {
					status[$(statusElement).attr('data-name')] = selectedStatus.classList.contains('complete-status')
				}
			})
			params['status'] = status
		}
		if (!_.isEmpty(params)) notificationInformation['params'] = params
		return notificationInformation;
	};
}
